var map = {
	"./iPhone-AUS.png": 6132,
	"./iPhone-AUS.webp": 9033,
	"./iPhone-CA-EN.png": 8977,
	"./iPhone-CA-EN.webp": 1434,
	"./iPhone-CA-FR.png": 1052,
	"./iPhone-CA-FR.webp": 8849,
	"./iPhone-ie.png": 4631,
	"./iPhone-ie.webp": 9908,
	"./iPhone-uk.png": 8733,
	"./iPhone-uk.webp": 142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7201;